<template>
  <div class="row">
    <div class="col-md-3" v-if="viewVeiculo">
      <b-card class="heightCardHeader" data-v-step="25">
        <b-card-title class="d-flex align-items-center justify-content-between">
          Veículos
        </b-card-title>
        <div>
          <div class="row">
            <div
              class="col-12 d-flex justify-content-center gap-4 align-items-center "
            >
              <div>
                <b-button
                  :disabled="listaVeiculo[indexVeiculo - 1] ? false : true"
                  @click="trocarVeiculo('atrasa')"
                  variant="primary"
                  size="md"
                  class="m-1"
                >
                  <i class="mdi mdi-arrow-left"></i>
                </b-button>
              </div>
              <b-card-img
                :src="
                  require(`@/assets/images/logo-marcas/${veiculo.cd_marca}.svg`)
                "
                class="rounded-0 col-8"
                style="width: 38%"
              ></b-card-img>
              <div>
                <b-button
                  :disabled="listaVeiculo[indexVeiculo + 1] ? false : true"
                  @click="trocarVeiculo('avanca')"
                  variant="primary"
                  size="md"
                  class="m-1"
                  data-v-step="26"
                >
                  <i class="mdi mdi-arrow-right"></i>
                </b-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <h4 class="font-bold">{{ veiculo.nm_versao }}</h4>
              <h5 class="text-muted">{{ veiculo.nm_categoria }}</h5>
              <h6 class="text-muted">
                {{ $tools.converteData(veiculo.dt_inicial.substr(0, 10)) }} A
                {{ $tools.converteData(veiculo.dt_final).substr(0, 10) }}
              </h6>
              <div class="col-md-12 d-flex justify-content-center">
                <div class="">
                  <div class="ms-3 me-3 bg-primary rounded-top">
                    <h6 class="font-size-10 m-0 text-white">BRASIL</h6>
                  </div>
                  <h4
                    class="mx-3 p-1 bg-light order border-secondary border-top-0 bg-gradient rounded-bottom"
                  >
                    {{ veiculo.ds_placa }}
                  </h4>
                </div>
              </div>
              <div class="col-12 text-center my-2">
                <span>
                  <i class="mdi mdi-circle text-primary align-middle me-1" />
                  KM Atual
                </span>
                <h4 class="font-bold">
                  {{ this.$tools.converteKM(veiculo.km_atual) }}
                </h4>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 text-center my-2">
              <span>
                <i class="mdi mdi-circle text-success align-middle me-1" />
                KM Percorrido
              </span>
              <h4 class="font-bold">
                {{ this.$tools.converteKM(veiculo.qt_km_percorrido) }}
              </h4>
            </div>
            <div class="col-6 text-center my-2">
              <span>
                <i class="mdi mdi-circle text-success align-middle me-1" />
                KM Particular
              </span>
              <h4 class="font-bold">
                {{ this.$tools.converteKM(veiculo.qt_km_particular) }}
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-6 text-center my-2">
              <span>KM Inicial</span>
              <h4 class="font-bold">
                {{ this.$tools.converteKM(veiculo.qt_km_inicial) }}
              </h4>
            </div>
            <div class="col-6 text-center my-2">
              <span>KM Final</span>
              <h4 class="font-bold" v-if="!editarKm">
                {{ this.$tools.converteKM(veiculo.qt_km_final) }}
              </h4>
              <div class="me-2 align-self-center mt-1" data-v-step="27">
                <b-button
                  variant="primary"
                  v-if="!editarKm && statusRdv"
                  @click="editarKmFinal()"
                  class="m-1"
                >
                  Editar Km Final
                </b-button>
              </div>
              <div v-if="editarKm">
                <div class="d-flex justify-content-center">
                  <b-form-group class="col-md-9">
                    <b-form-input v-model="kmFinal" type="number" />
                  </b-form-group>
                </div>
                <b-button
                  @click="editarKmFinal()"
                  variant="secondary"
                  size="md"
                  class="m-2"
                >
                  Cancelar
                </b-button>
                <b-button
                  @click="atualizarKmFinal()"
                  variant="primary"
                  size="md"
                  class="m-1"
                >
                  Alterar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="col-md-9" v-if="viewDespesas" data-v-step="28">
      <b-card class="heightCardHeader">
        <b-card-title class="d-flex justify-content-between">
          <label>Gerenciamento de Km</label>
          <!-- <div class="col-md-12 d-flex justify-content-center">
          <div class="">
            <div class="ms-3 me-3 bg-primary rounded-top">
              <h6 class="font-size-10 m-0 text-white">BRASIL</h6>
            </div>
            <h4 class="mx-3 p-1 bg-light order border-secondary 
                      border-top-0 bg-gradient rounded-bottom">
              {{veiculo.ds_placa}}
            </h4>
          </div>
        </div> -->

          <b-button
            variant="primary"
            @click="incluirKmParticular()"
            v-if="statusRdv"
            data-v-step="29"
          >
            <i class="bx bx-plus font-size-16 align-middle me-1"></i>
            Incluir KM Particular
          </b-button>
        </b-card-title>
        <b-table
          class="datatables"
          responsive="sm"
          :items="tabelaCombustivel"
          :fields="camposCombustivel"
          per-page="8"
          :current-page="currentPage"
          striped
        >
          <template #head()="data">
            <div class="text-center">
              <span
                :data-tooltip="getDescricao(data)"
                data-tooltip-location="top"
                >{{ data.label }}</span
              >
            </div>
          </template>
          <template v-slot:cell(placa)="data">
            <div class="text-center">
              <span>{{ data.item.ds_placa }}</span>
            </div>
          </template>
          <template v-slot:cell(km_particular_percorrido)="data">
            <div class="text-center">
              <span>
                {{ data.item.st_origem === "P" ? "Particular" : "Trabalho" }}
              </span>
            </div>
          </template>
          <template v-slot:cell(nota)="data">
            <i
              v-if="data.item.sq_lancamento"
              @click="$emit('comprovante', data.item.sq_lancamento)"
              class="mdi mdi-newspaper-variant font-size-16 align-middle div-clickable"
            ></i>
          </template>
          <template v-slot:cell(ds_aprovado)="data">
            <span
              class="badge badge-pill font-size-12"
              :class="{
                'badge-soft-warning':
                  data.item.st_lancamento === 'Pendente' ||
                  data.item.st_lancamento === 'Pré-Aprovado',
                'badge-soft-success': data.item.st_lancamento === 'Aprovado',
                'badge-soft-secondary': data.item.st_lancamento === 'Pré-Rejeitado',
                'badge-soft-info': data.item.st_lancamento === 'Liberado',
                'badge-soft-danger':
                  data.item.st_lancamento === 'bloqueado' ||
                  data.item.st_lancamento === 'Rejeitado',

              }"
            >
              {{ data.item.st_lancamento }}
            </span>
          </template>
          <template v-slot:cell(editar)="data">
            <router-link
              v-if="
                statusRdv &&
                  data.item.st_aprovado == 'N' &&
                  data.item.st_lancamento !== 'Pré-Aprovado' &&  data.item.st_lancamento !== 'Aprovado' && data.item.st_lancamento !== 'Bloqueado' && data.item.st_lancamento !== 'Rejeitado' && data.item.st_lancamento !== 'Pré-Rejeitado' 
              "
              :to="
                '/cooperado/rdv/kmParticular/?sq_gerenciamento=' +
                  data.item.sq_gerenciamento +
                  '&sq_veiculo=' +
                  data.item.sq_veiculo +
                  '&sq_lancamento=' +
                  data.item.sq_lancamento
              "
            >
              <b-button variant="primary" class="me-2">
                <i class="mdi mdi-lead-pencil font-size-16" />
              </b-button>
            </router-link>
            <b-button
              v-show="
                statusRdv &&
                  data.item.st_aprovado == 'N' &&
                  data.item.sq_lancamento == null &&
                  !(data.item.st_origem == 'R' || data.item.st_origem == 'D')
              "
              variant="danger"
              class="me-2"
              :disabled="loadingExcluir"
              @click="excluirAbastecimento(data.item)"
            >
              <i class="mdi mdi-trash-can font-size-16" />
              <b-spinner small class="ms-2" v-if="loadingExcluir"></b-spinner>
            </b-button>
          </template>
        </b-table>
        <div class="dataTables_paginate paging_simple_numbers float-end m-2">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              per-page="8"
            ></b-pagination>
          </ul>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statusRdv: Boolean
  },
  data() {
    return {
      filroKmParticular: [],
      listaVeiculo: [],
      veiculo: {},
      indexVeiculo: 0,
      viewVeiculo: false,
      veiculoAnterio: true,
      proximoVeiculo: true,
      viewDespesas: false,
      tomador: [],
      tabelaCombustivel: [],
      camposCombustivel: [
        // {
        //   key: "sq_lancamento",
        //   label: "Código",
        //   class: "alinharCelula",
        //   descricao: "testeeee",
        //   sortable: true,
        // },
        {
          key: "dt_gerenciamento",
          label: "Data",
          descricao: "Data de lançamento",
          class: "alinharCelula",
          formatter: value => {
            return this.$tools.converteData(value).substr(0, 10);
          },
          sortable: true
        },
        {
          key: "placa",
          label: "Placa",
          descricao: "Placa do veículo",
          class: "alinharCelula"
        },
        {
          key: "qt_km_inicial",
          label: "Inicial",
          class: "alinharCelulaDireita",
          descricao: "KM Inicial do hodômetro ",
          formatter: value => {
            return this.$tools.converteKM(value);
          },
          sortable: true
        },
        {
          key: "qt_km_final",
          label: "Final",
          descricao: "KM Final do Hodômetro ",
          class: "alinharCelulaDireita",
          formatter: value => {
            return this.$tools.converteKM(value);
          },
          sortable: true
        },
        {
          key: "qt_km_percorrido",
          label: "Percorrido",
          descricao: "KM Percorrido",
          class: "alinharCelulaDireita",
          formatter: value => {
            return this.$tools.converteKM(value);
          },
          sortable: true
        },
        {
          key: "km_particular_percorrido",
          label: "Uso",
          descricao: "Forma de Uso: A Trabalho ou Particular ",
          class: "alinharCelulaDireita",
          formatter: value => {
            return this.$tools.converteKM(value);
          },
          sortable: true
        },
        {
          key: "vl_lancamento",
          label: "Valor",
          class: "alinharCelulaDireita",
          descricao: "Valor da despesa",
          formatter: value => {
            return this.$tools.converteReal(value);
          },
          sortable: true
        },
        {
          key: "nota",
          label: "Nota",
          descricao: "Clique aqui para visualizar o comprovante",
          class: "alinharCelula"
        },
        {
          key: "ds_aprovado",
          label: "Situação",
          descricao: "Situação do gerenciamento de KM",
          class: "alinharCelula",
          sortable: true
        },
        {
          key: "editar",
          label: "",
          class: "alinharCelulaDireita",
          sortable: true
        }
      ],
      currentPage: 1,
      rows: 0,
      editarKm: false,
      kmFinal: "",
      loadingExcluir: false
    };
  },

  mounted() {
    this.filtroTomador();
  },

  methods: {
    inputDadosFakeTour(dados) {
      if (dados == "Tirar dados fakes") {
        this.viewVeiculo = false;
        this.viewDespesas = false;
        this.veiculo = {};
        this.tabelaCombustivel = [];
        return;
      }
      this.viewVeiculo = true;
      this.viewDespesas = true;
      this.veiculo = dados;
      this.tabelaCombustivel = [dados];
    },

    filtrarVeiculo(cdRdv) {
      this.$http
        .get("api/telemetria/relatorioVeicularRdv/" + cdRdv)
        .then(response => {
          this.listaVeiculo = response.data;
          this.indexVeiculo = 0;
          this.veiculo = this.listaVeiculo[0];
          this.$store.commit("PARAMETROS_VEICULO_COOPERADO", {
            index: "listaVeiculo",
            item: this.listaVeiculo
          });
          this.$store.commit("PARAMETROS_VEICULO_COOPERADO", {
            index: "veiculo",
            item: this.veiculo
          });
          this.filtrarDespesasCombustivel(cdRdv, this.veiculo.sq_veiculo);
          this.viewVeiculo = true;
        })
        .catch(() => {
          console.log(
            "Não foi encontrado veículo cadastrado. Possivelmente usuário não gerencia KM."
          );
        });
    },
    filtroTomador() {
      this.$http
        .get("api/cooperado/filtrarProjeto")
        .then(response => {
          this.tomador = response.data;
        })
        .catch(() => {
          console.log(
            "Não foi encontrado veículo cadastrado. Possivelmente usuário não gerencia KM."
          );
        });
    },
    getDescricao(data) {
      const obj = this.camposCombustivel.find(
        item => item.label === data.label
      );
      if (obj) return obj.descricao;
      return "";
    },
    filtrarDespesasCombustivel(cdRdv, sqVeiculo) {
      this.$http
        .get(
          "api/telemetria/relatorioGastoCombustivel/" + cdRdv + "/" + sqVeiculo
        )
        .then(response => {
          const filtroVeiculo = Array.from(
            new Set(response.data.map(a => a.sq_gerenciamento))
          ).map(sq_gerenciamento => {
            return response.data.find(
              a => a.sq_gerenciamento === sq_gerenciamento
            );
          });

          this.tabelaCombustivel = filtroVeiculo;
          this.viewDespesas = true;
          this.rows = this.tabelaCombustivel.length;
        });
    },

    trocarVeiculo(acao) {
      if (acao == "avanca") {
        this.indexVeiculo++;
        this.veiculo = this.listaVeiculo[this.indexVeiculo];
      } else {
        this.indexVeiculo--;
        this.veiculo = this.listaVeiculo[this.indexVeiculo];
      }
      this.$store.commit("PARAMETROS_VEICULO_COOPERADO", {
        index: "veiculo",
        item: this.veiculo
      });
      this.filtrarDespesasCombustivel(
        this.veiculo.cd_rdv,
        this.veiculo.sq_veiculo
      );
    },

    editarKmFinal() {
      this.editarKm = !this.editarKm;
    },

    incluirKmParticular() {
      this.$router.push({ path: "rdv/kmParticular/" });
    },

    atualizarKmFinal() {
      this.$http
        .post("api/rdvCooperado/veiculo/atualizarKmFinal", {
          cd_rdv: this.veiculo.cd_rdv,
          sq_veiculo: this.veiculo.sq_veiculo,
          sq_gerenciamento: this.tabelaCombustivel[
            this.tabelaCombustivel.length - 1
          ].sq_gerenciamento,
          qt_km_inicial: this.tabelaCombustivel[
            this.tabelaCombustivel.length - 1
          ].qt_km_inicial,
          qt_km_final: this.kmFinal
        })
        .then(() => {
          this.$tools.alerta("Item incluido com sucesso", "success");
          this.editarKm = !this.editarKm;
          this.veiculo.qt_km_final = this.kmFinal;
          this.tabelaCombustivel[
            this.tabelaCombustivel.length - 1
          ].qt_km_final = this.kmFinal;
        })
        .catch(err => {
          this.$tools.alerta(err.response.data.message, "error");
        });
    },

    limparPesquisa() {
      this.viewVeiculo = false;
      this.viewDespesas = false;
    },

    async excluirAbastecimento(item) {
      try {
        await this.$tools.alertaConfirm(
          "Tem certeza que deseja excluir o abastecimento?"
        );
      } catch {
        return;
      }
      this.loadingExcluir = true;
      this.$http
        .post("api/rdvCooperado/veiculo/excluirKmParticular", {
          cd_rdv: item.cd_rdv,
          sq_veiculo: item.sq_veiculo,
          sq_gerenciamento: item.sq_gerenciamento,
          dt_gerenciamento: item.dt_gerenciamento
        })
        .then(() => {
          this.loadingExcluir = false;
          this.$tools.alerta("Removido com sucesso", "success");
          this.filtrarVeiculo(item.cd_rdv);
        })
        .catch(err => {
          this.loadingExcluir = false;
          this.$tools.alerta(err.response.data.message, "error");
        });
    }
  }
};
</script>
